import React from "react";
import { FormattedMessage, IntlProvider, useIntl } from "react-intl";
import Header from "@shared/components/Header";
import Loader from "@shared/components/Loader";
import Footer from "@shared/components/Footer";
import Main from "@shared/components/Main";
import Description from "@shared/components/Description";
import PreviewScreenshots from "@shared/components/PreviewScreenshots";
import StoreLinks from "@shared/components/StoreLinks";
import Contacts from "@shared/components/Contacts";
import { useData } from "@shared/context/Data";
import styles from "@shared/styles/app.styles.css";
const logo = require("../../assets/logo1024.png");
const firstPreviewScreenshot = require("../../assets/1.jpeg");
const seconfPreviewScreenshot = require("../../assets/2.jpeg");
const thirdPreviewScreenshot = require("../../assets/3.jpeg");
const fourdPreviewScreenshot = require("../../assets/4.jpeg");
const fifthPreviewScreenshot = require("../../assets/5.jpeg");
const previewScreenshots = [
    {
        src: firstPreviewScreenshot,
        alt: `${CITY_NAME} Guide`
    },
    {
        src: seconfPreviewScreenshot,
        alt: "Self-guided routes"
    },
    {
        src: thirdPreviewScreenshot,
        alt: "Itenerary points"
    },
    {
        src: fourdPreviewScreenshot,
        alt: "Description and Audio"
    },
    {
        src: fifthPreviewScreenshot,
        alt: "Easy-to-use Map"
    }
];
function HeaderWithIntl() {
    const intl = useIntl();
    return (React.createElement(Header, { link: PAGE_PATH, logoSrc: logo, logoAlt: intl.formatMessage({ id: "LogoAltText" }), mainTitle: React.createElement(FormattedMessage, { id: "MainTitle", values: { city: CITY_NAME } }) }));
}
function App() {
    const { messages, language, isLoading } = useData();
    return (React.createElement(IntlProvider, { locale: language, messages: messages }, isLoading
        ? React.createElement(Loader, null)
        : (React.createElement("div", { className: styles.container },
            React.createElement(HeaderWithIntl, null),
            React.createElement(Main, null,
                React.createElement(PreviewScreenshots, { items: previewScreenshots }),
                React.createElement(StoreLinks, { appStoreUrl: APP_STORE_URL }),
                React.createElement(Description, { city: CITY_NAME }),
                React.createElement(Contacts, null)),
            React.createElement(Footer, null)))));
}
export default App;
